import { API_HOST } from '../api/Configuration';
import ServiceLocator from '../services/ServiceLocator'

//simplify api calls
export default class ApiClient {
    private _host: string;

    public constructor() {
        this._host = API_HOST;
    }

    public Get<T>(relativeUrl: string): Promise<T> {
        return this.Send(relativeUrl, null, 'GET');
    }

    public Post<T>(relativeUrl: string, body: any): Promise<T> {
        return this.Send(relativeUrl, body, 'POST');
    }

    public Patch<T>(relativeUrl: string, body: any): Promise<T> {
        return this.Send(relativeUrl, body, 'PATCH');
    }

    public Delete<T>(relativeUrl: string, body: any): Promise<T> {
        return this.Send(relativeUrl, body, 'DELETE');
    }

    private Send<T>(relativeUrl: string, body: any, method: string): Promise<T> {
        let request = this.CreateRequest(method, relativeUrl);
        this.SendRequest(request, body);
        return this.CreateResponsePromise<T>(request);
    }

    private CreateRequest(method: string, relativeUrl: string): XMLHttpRequest {
        let request = new XMLHttpRequest();
        let url = this._host + relativeUrl;

        request.open(method, url, true);

        request.setRequestHeader('Accept', 'application/json');

        if (method !== 'GET') {
            request.setRequestHeader('Content-Type', 'application/json');
        }

        ServiceLocator.Authenticator.Authenticate(request);
        return request;
    }

    private SendRequest(request: XMLHttpRequest, body: any = null) {
        if (body === null) {
            request.send();
        }
        else {
            request.send(JSON.stringify(body));
        }
    }

    private CreateResponsePromise<T>(request: XMLHttpRequest): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            request.onreadystatechange = () => {
                if (request.readyState !== 4) return;

                const isSuccess = request.status >= 200 && request.status < 300;
                const isClientError = request.status >= 400 && request.status < 500;

                try {
                    const jsonResponse = JSON.parse(request.responseText);
                    if (isSuccess || isClientError) {
                        resolve(jsonResponse);
                    } else {
                        reject(request.status);
                    }
                } catch (error) {
                    reject(error);
                }
            };
        });
    }

}
